/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_Next_RoundInputs */



/**
* | output |
* | --- |
* | "Next round" |
*
* @param {Decks_Next_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_next_round = /** @type {((inputs?: Decks_Next_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Next_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prochaine ronde")
	if (locale === "es") return /** @type {LocalizedString} */ ("Próxima ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Próxima rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prossimo round")
	return /** @type {LocalizedString} */ ("Next round")
});